import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Installer
import ClaimSubmitted from '../components/installer/ClaimSubmitted';
import Guidance from '../components/installer/Guidance';
import ConfirmSubContractor from '../components/installer/ConfirmSubContractor';
import GrantAmount from '../components/installer/GrantAmount';
import Subcontractor from '../components/installer/Subcontractor';
import DeclarationInstaller from '../components/installer/DeclarationInstaller';
import InstallationDate from '../components/installer/InstallationDate';
import OverAllocationOfSockets from '../components/installer/OverAllocationOfSockets';
import InstallationCost from '../components/installer/InstallationCost';
import UnderAllocationOfSockets from '../components/installer/UnderAllocationOfSockets';
import ChargepointsDetails from '../components/installer/ChargepointDetails';
import CheckYourAnswers from '../components/installer/CheckYourAnswers';
import ChargepointsSummary from '../components/installer/ChargepointsSummary';
import AddAdditionalChargepoints from '../components/installer/AddAdditionalChargepoints';
import AddAdditionalDetails from '../components/installer/AddAdditionalDetails';
import RequestLinkForPassword from '../components/installer/RequestLinkForPassword';
import LinkRequested from '../components/LinkRequested';
import AuthRoute from '../AuthRoute';

export default function RoutesTreeInstaller() {
  return (
    <Switch>
      {/* ***************** */}
      {/* Installer routes  */}
      {/* ***************** */}
      <Route exact path="/installer/installer-account-guidance">
        <Guidance />
      </Route>
      <Route exact path="/installer/request-link-for-password">
        <RequestLinkForPassword />
      </Route>
      <Route exact path="/installer/link-requested-confirmation">
        <LinkRequested />
      </Route>
      <AuthRoute exact path="/installer/declaration">
        <DeclarationInstaller />
      </AuthRoute>
      {/* The following three Routes are created with a component prop in order to have location
      prop passed to it by the Change Link on the CheckYourPropertyAnswers screen */}
      <AuthRoute
        exact
        path="/installer/subcontractor"
        component={Subcontractor}
      />
      <AuthRoute
        exact
        path="/installer/confirm-subcontractor-details"
        component={ConfirmSubContractor}
      />
      <AuthRoute
        exact
        path="/installer/installation-cost"
        component={InstallationCost}
      />
      <AuthRoute exact path="/installer/chargepoints-details">
        <ChargepointsDetails />
      </AuthRoute>
      <AuthRoute
        exact
        path="/installer/additional-chargepoints-details"
        component={AddAdditionalDetails}
      />
      <AuthRoute exact path="/installer/claim-submitted">
        <ClaimSubmitted />
      </AuthRoute>
      <AuthRoute
        exact
        path="/installer/installation-date"
        component={InstallationDate}
      />
      <AuthRoute exact path="/installer/grant-amount">
        <GrantAmount />
      </AuthRoute>
      <AuthRoute exact path="/installer/check-your-answers">
        <CheckYourAnswers />
      </AuthRoute>
      <AuthRoute exact path="/installer/socket-over-allocation">
        <OverAllocationOfSockets />
      </AuthRoute>
      <AuthRoute exact path="/installer/socket-under-allocation/:s?">
        <UnderAllocationOfSockets />
      </AuthRoute>
      <AuthRoute exact path="/installer/chargepoints-summary">
        <ChargepointsSummary />
      </AuthRoute>
      <AuthRoute exact path="/installer/additional-chargepoints">
        <AddAdditionalChargepoints />
      </AuthRoute>
    </Switch>
  );
}
